import { useCallback, useEffect, useState } from "react";
import useAlertsNotifications from "../../useAlertsNotifications/useAlertsNotifications";

export default function AlertFunction() {
  const [alert, setAlert] = useState(null);
  const [alertText, setAlertText] = useState(null);

  const { alertsTypes } = useAlertsNotifications();

  useEffect(() => {
    const interval = setInterval(() => {
      clear();
    }, 30000);

    return () => clearInterval(interval);
  }, [alert]);

  const STATES = {
    SUCCESS: "success",
    ERROR: "error",
    WARNING: "warning",
  };

  const success = useCallback((text) => {
    setAlertText(text);
    setAlert(STATES.SUCCESS);
  }, []);

  const error = useCallback((text) => {
    setAlertText(text);
    setAlert(STATES.ERROR);
  }, []);

  const warning = useCallback((error) => {
    if (error?.documentPowerDenied) {
      setAlertText(alertsTypes.AlertDocumentPower);
      setAlert(STATES.WARNING);
      return;
    }

    switch (error.status) {
      case 424:
        setAlertText(alertsTypes.AlertMcLeod);
        setAlert(STATES.WARNING);
        break;
      case 422:
        if (Object.keys(error.rspJson.errors)) {
          let newAlertText = "";
          for (const [, value] of Object.entries(error.rspJson.errors)) {
            let alerts = value;
            newAlertText = `${alerts} ${newAlertText}`;
          }
          setAlertText(newAlertText);
          setAlert(STATES.WARNING);
        }
        break;
      default:
        setAlertText(error);
        setAlert(STATES.WARNING);
        break;
    }
  }, []);

  const clear = useCallback(() => {
    setAlertText(null);
    setAlert(null);
  }, []);

  return {
    alert,
    alertText,
    success,
    error,
    warning,
    clear
  };
}